export const eventNames = {
  100: "throws a last dart Bullseye",
  101: "has a Quackshot Quacktrick",
  102: "steals the lead",
  103: "steals the lead in Shanghai",
  104: "makes a Demolition Checkout",
  105: "makes the Final kill",
  106: "throws a last dart triple",
  107: "completes Snakes & Ladders",
  108: "finishes the Donkey Derby",
  109: "throws a Donkey Derby Bullseye!",
  110: "throws a last dart triple",
  111: "levels at Limbo",
  112: "wins at Limbo",
  113: "scores under 50mm!",
  114: "throws a last dart Bullseye!",
};
